import { Component } from 'react';
import { css } from '@emotion/react';
import { TooltipContent } from './TooltipContent';
import { TooltipArrow } from './TooltipArrow';
import { extractPositioningStyles, isOnAxis, extractOffset } from './utils';
import { Alignment, PositionType } from './Tooltip';

export const TOOLTIP_CONTAINER_CLASSNAME = '__mapui_tooltip_container';

export interface InternalOffset {
  up: number;
  down: number;
  left: number;
  right: number;
  hasNegative: boolean;
}

export interface InternalArrow {
  position: string;
}

const containerStyle = (side: PositionType) => (theme: any) => {
  const container = css(theme.tooltip.container);
  const sideStyle = css(theme.tooltip.side[side]);

  const styles = [container, sideStyle];

  return css(...styles);
};

export interface InternalTooltipProps {
  position: PositionType;
  alignment: Alignment;
  offsetDown?: string;
  offsetRight?: string;
  offsetLeft?: string;
  offsetUp?: string;
  width: string;
}

export class TooltipContainer extends Component<InternalTooltipProps> {
  render() {
    const {
      position,
      alignment,
      offsetDown = '0px',
      offsetRight = '0px',
      offsetLeft = '0px',
      offsetUp = '0px',
      width,
      // eslint-disable-next-line react/prop-types
      children,
    } = this.props;

    const onAxis = isOnAxis(position);
    const offsets = extractOffset(
      onAxis,
      offsetDown,
      offsetUp,
      offsetLeft,
      offsetRight
    );

    const adjustment = `${offsets.down}px ${offsets.left}px ${offsets.up}px ${offsets.right}px`;

    const tooltipStyle = {
      ...extractPositioningStyles(position),
      padding: offsets.hasNegative ? null : adjustment,
      margin: offsets.hasNegative ? adjustment : null,
    };

    const arrow: InternalArrow = {
      position: alignment,
    };
    arrow.position = onAxis.y ? `h-${arrow.position}` : `v-${arrow.position}`;

    return (
      <div
        className={TOOLTIP_CONTAINER_CLASSNAME}
        css={containerStyle(position)}
        style={tooltipStyle}
      >
        <TooltipArrow />
        <TooltipContent
          position={position}
          arrow={arrow}
          offsets={offsets}
          width={width}
        >
          {children}
        </TooltipContent>
      </div>
    );
  }
}
